export const COOKIE_CONSENT_KEY = 'cookie-consent.answer';
export const PWA_INSTALL_ANSWER_KEY = 'pwa-install.answer';
export const COOKIE_CONSENT_ALLOW_VALUE = 'allow';
export const PWA_INSTALL_NOT_NOW_VALUE = 'notnow';

export function getStoredStringValue(key: string): string | null {
  const rawValue = localStorage.getItem(key);

  if (rawValue === null) {
    return null;
  }

  try {
    const parsedValue = JSON.parse(rawValue);
    return typeof parsedValue === 'string' ? parsedValue : rawValue;
  } catch {
    return rawValue;
  }
}

export function setStoredStringValue(key: string, value: string): void {
  localStorage.setItem(key, JSON.stringify(value));
}

export function hasCookieConsent(): boolean {
  return getStoredStringValue(COOKIE_CONSENT_KEY) === COOKIE_CONSENT_ALLOW_VALUE;
}

export function isInstallPromptDismissed(): boolean {
  return getStoredStringValue(PWA_INSTALL_ANSWER_KEY) === PWA_INSTALL_NOT_NOW_VALUE;
}
